import React from 'react';
import { Select, Button, Spin } from 'antd';
import { useWidgetContext } from '../../context/widget';

import { CreateWidgetModal } from './widget-create-modal';
import { PlusOutlined } from '@ant-design/icons';

export const WidgetSelector: React.FC = () => {
  const { selectedWidgetId, setSelectedWidgetId, widgets, isLoading } = useWidgetContext();

  const [createModalOpen, setCreateModalOpen] = React.useState(false);

  const handleWidgetCreated = (widgetId: string) => {
    // Recargar la lista de widgets
    setSelectedWidgetId(widgetId);
  };

  return (
    <>
      <div style={{ padding: '0 20px 20px 20px', width: '100%' }}>
        {isLoading ? (
          <Spin size='small' />
        ) : widgets.length === 0 ? (
          <div style={{ color: '#8c8c8c', fontSize: 12 }}>No hay widgets</div>
        ) : (
          <Select
            value={selectedWidgetId}
            onChange={setSelectedWidgetId}
            style={{ width: '100%' }}
            placeholder='Seleccionar widget'
            options={widgets.map(widget => ({
              value: widget.widgetId,
              label: widget.settings?.title || widget.widgetId
            }))}
          />
        )}

        {/* Botón nuevo para crear widget */}
        <Button
          block
          type='dashed'
          icon={<PlusOutlined />}
          onClick={() => setCreateModalOpen(true)}
          style={{ marginTop: 8 }}
        >
          Nuevo widget
        </Button>
      </div>

      <CreateWidgetModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSuccess={handleWidgetCreated}
      />
    </>
  );
};
